<div fxLayout="column" ngClass.desktop="pl-56 pr-56 pt-48 pb-48 shadow-content" ngClass.mobile="pt-24 pl-16 pr-16 w-100 mt-40"
     fxFlexAlign="center" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="start center">
        <div class="h2-semi-bold">{{ 'i18n_auth_iinDetailed' |  translate: {iin: iin} }}</div>
        <div class="t2 mt-8">{{ 'i18n_auth_iinCheckDescription' | translate }}</div>
        <ui-kit-button
            fxLayout="column"
            class="mt-36"
            (clickListener)="submit()"
            ngClass.mobile="w-100"
            [disabled]="agreementsRequired && !agreementsChecked"
            [label]="'i18n_auth_buttonConfirm' | translate"
            [autoFocus]="true">
        </ui-kit-button>
    </div>
    @if (agreementsRequired) {
        <ui-kit-checkbox class="mt-16" appearance="small"
                         [checked]="agreementsChecked"
                         (change)="agreementsChecked = $event.checked">
            <span class="t4 c-primary-gray-900 underline-links"
                  [innerHTML]="'i18n_auth_userAgreementAndPrivacyPolicy' | translate:
         {userAgreementUrl: userAgreementUrl, privacyPolicyUrl: privacyPolicyUrl, target: documentsTarget}"></span>
        </ui-kit-checkbox>
    }
</div>
